(function () {
  function initSizeCharts(root) {
    (root || document).querySelectorAll('[data-size-chart]').forEach(function (wrap) {
      if (wrap.dataset.inited === '1') return;
      wrap.dataset.inited = '1';

      var radios = wrap.querySelectorAll('[data-unit-radio]');
      var tables = wrap.querySelectorAll('[data-unit]');

      function setUnit(unit) {
        tables.forEach(function (el) {
          el.hidden = (el.getAttribute('data-unit') !== unit);
        });
        try { localStorage.setItem('size_chart_unit', unit); } catch (e) {}
      }

      var saved = 'cm';
      try { saved = localStorage.getItem('size_chart_unit') || 'cm'; } catch (e) {}

      var savedRadio = wrap.querySelector('[data-unit-radio][value="' + saved + '"]');
      if (savedRadio) savedRadio.checked = true;
      setUnit(saved);

      wrap.addEventListener('change', function (e) {
        if (e.target && e.target.matches('[data-unit-radio]')) {
          setUnit(e.target.value);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSizeCharts(document);
  });

  /* Theme editor reload support */
  document.addEventListener('shopify:section:load', function (event) {
    initSizeCharts(event.target);
  });
})();
